'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n    ', '\n'], ['\n    ', '\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    letter-spacing: 0;\n    font-size: 13px;\n    font-family: ', ';\n    text-align: center;\n    height: 55px;\n    padding-bottom: 15px;\n    \n    ', '\n    \n    .glyphicon {\n        padding-right: 5px;\n    }\n'], ['\n    display: flex;\n    letter-spacing: 0;\n    font-size: 13px;\n    font-family: ', ';\n    text-align: center;\n    height: 55px;\n    padding-bottom: 15px;\n    \n    ', '\n    \n    .glyphicon {\n        padding-right: 5px;\n    }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n        display: none;\n    '], ['\n        display: none;\n    ']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n    height: 310px;\n    overflow: scroll;\n    width: 100%;\n    float: left;\n    display: ', ';\n    \n    ', '\n'], ['\n    height: 310px;\n    overflow: scroll;\n    width: 100%;\n    float: left;\n    display: ', ';\n    \n    ', '\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n        display: inherit;\n        height: 475px;\n        width: 37.5%;\n    '], ['\n        display: inherit;\n        height: 475px;\n        width: 37.5%;\n    ']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n    width: 100%;\n    float: left;\n    display: ', ';\n    \n    ', '\n'], ['\n    width: 100%;\n    float: left;\n    display: ', ';\n    \n    ', '\n']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n        display: inherit;\n        width: calc(62.5% - 30px);\n        margin-left: 30px;\n    '], ['\n        display: inherit;\n        width: calc(62.5% - 30px);\n        margin-left: 30px;\n    ']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n    border: 1px solid #C5B3AF;\n'], ['\n    border: 1px solid #C5B3AF;\n']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    \n    img {\n        width: 33px;\n        padding-top: 5px;\n    }\n    \n    div {\n        padding: 25px 10px;\n        font-size: 14px;\n        \n        ', '\n    }\n'], ['\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    \n    img {\n        width: 33px;\n        padding-top: 5px;\n    }\n    \n    div {\n        padding: 25px 10px;\n        font-size: 14px;\n        \n        ', '\n    }\n']),
    _templateObject10 = _taggedTemplateLiteralLoose(['\n            padding: 30px 10px;\n            font-size: 16px;\n        '], ['\n            padding: 30px 10px;\n            font-size: 16px;\n        ']),
    _templateObject11 = _taggedTemplateLiteralLoose(['\n    display: ', ';\n    padding: 40px 25px 60px;\n    \n    ', '\n'], ['\n    display: ', ';\n    padding: 40px 25px 60px;\n    \n    ', '\n']),
    _templateObject12 = _taggedTemplateLiteralLoose(['\n    width: 50%;\n    height: 100%;\n    padding-top: 12px;\n    border-radius: 2px 0 0 2px;\n    border: 1px solid;\n    border-color: ', ';\n    color: ', ';\n    background: ', ';\n'], ['\n    width: 50%;\n    height: 100%;\n    padding-top: 12px;\n    border-radius: 2px 0 0 2px;\n    border: 1px solid;\n    border-color: ', ';\n    color: ', ';\n    background: ', ';\n']),
    _templateObject13 = _taggedTemplateLiteralLoose(['\n    width: 50%;\n    height: 100%;\n    padding-top: 12px;\n    border-radius: 0 2px 2px 0;\n    border: 1px solid;\n    border-color: ', ';\n    color: ', ';\n    background: ', ';\n    display: flex;\n    justify-content: center;\n'], ['\n    width: 50%;\n    height: 100%;\n    padding-top: 12px;\n    border-radius: 0 2px 2px 0;\n    border: 1px solid;\n    border-color: ', ';\n    color: ', ';\n    background: ', ';\n    display: flex;\n    justify-content: center;\n']),
    _templateObject14 = _taggedTemplateLiteralLoose(['\n  padding-left: 5px;\n'], ['\n  padding-left: 5px;\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsHelper = require('../../lib/styledComponentsHelper');

var _ListIcon = require('../Icons/ListIcon');

var _ListIcon2 = _interopRequireDefault(_ListIcon);

var _MapIcon = require('../Icons/MapIcon');

var _MapIcon2 = _interopRequireDefault(_MapIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var LocationsContainerStyled = _styledComponents2.default.div(_templateObject, (0, _styledComponentsHelper.clearfix)());

var MapListSwitcherStyled = _styledComponents2.default.div(_templateObject2, _styledComponentsHelper.fontFamilies.bold, _styledComponentsHelper.media.md(_templateObject3));

var ResultsContainer = _styledComponents2.default.div(_templateObject4, function (props) {
    return props.showInMobileView ? 'inherit' : 'none';
}, _styledComponentsHelper.media.md(_templateObject5));

var MapContainer = _styledComponents2.default.div(_templateObject6, function (props) {
    return props.showInMobileView ? 'inherit' : 'none';
}, _styledComponentsHelper.media.md(_templateObject7));

var MapBorderStyled = _styledComponents2.default.div(_templateObject8);

var PlaceholderStyled = _styledComponents2.default.div(_templateObject9, _styledComponentsHelper.media.md(_templateObject10));

var MapContainerPlaceholderText = _styledComponents2.default.div(_templateObject11, function (props) {
    return props.show ? 'inherit' : 'none';
}, _styledComponentsHelper.media.md(_templateObject3));

var ListButtonStyled = _styledComponents2.default.div(_templateObject12, function (props) {
    return props.selected ? '#6E4D40' : '#C5B3AF';
}, function (props) {
    return props.selected ? '#FFFFFF' : '#8b7166';
}, function (props) {
    return props.selected ? '#6E4D40' : 'inherit';
});

var MapButtonStyled = _styledComponents2.default.div(_templateObject13, function (props) {
    return props.selected ? '#6E4D40' : '#C5B3AF';
}, function (props) {
    return props.selected ? '#FFFFFF' : '#8b7166';
}, function (props) {
    return props.selected ? '#6E4D40' : 'inherit';
});

var SpanStyled = _styledComponents2.default.span(_templateObject14);

var LocationsContainer = function (_Component) {
    _inherits(LocationsContainer, _Component);

    function LocationsContainer(props) {
        _classCallCheck(this, LocationsContainer);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.switchView = function () {
            _this.setState({
                showList: !_this.state.showList,
                showMap: !_this.state.showMap
            });
        };

        _this.state = {
            showList: false,
            showMap: true
        };
        return _this;
    }

    LocationsContainer.prototype.render = function render() {
        var defaultSearchForRestaurant = 'Search for a restaurant location using city, state, or zip code or search for the restaurant number from your receipt.';
        var placeholder = this.props.locations.length ? '' : _react2.default.createElement(
            PlaceholderStyled,
            null,
            _react2.default.createElement('img', { src: '/images/common/icons/Fill_16@2x.png' }),
            _react2.default.createElement(
                'div',
                null,
                this.props.getLocalizedText('SearchForRestaurant', defaultSearchForRestaurant)
            )
        );

        return _react2.default.createElement(
            LocationsContainerStyled,
            null,
            _react2.default.createElement(
                MapListSwitcherStyled,
                null,
                _react2.default.createElement(
                    ListButtonStyled,
                    { selected: this.state.showList, onClick: this.switchView },
                    _react2.default.createElement(_ListIcon2.default, { color: this.state.showList ? "#FFF" : "#8B7166" }),
                    _react2.default.createElement(
                        SpanStyled,
                        null,
                        'List'
                    )
                ),
                _react2.default.createElement(
                    MapButtonStyled,
                    { selected: this.state.showMap, onClick: this.switchView },
                    _react2.default.createElement(_MapIcon2.default, { color: this.state.showMap ? "#FFF" : "#8B7166" }),
                    _react2.default.createElement(
                        SpanStyled,
                        null,
                        'Map'
                    )
                )
            ),
            _react2.default.createElement(
                ResultsContainer,
                { showInMobileView: this.state.showList },
                placeholder,
                this.props.locations
            ),
            _react2.default.createElement(
                MapContainer,
                { showInMobileView: this.state.showMap },
                _react2.default.createElement(
                    MapBorderStyled,
                    null,
                    this.props.map
                ),
                _react2.default.createElement(
                    MapContainerPlaceholderText,
                    { show: !this.props.locations.length },
                    placeholder
                )
            )
        );
    };

    return LocationsContainer;
}(_react.Component);

LocationsContainer.propTypes = {
    locations: _propTypes2.default.array,
    map: _propTypes2.default.element,
    getLocalizedText: _propTypes2.default.func,
    locale: _propTypes2.default.shape({
        country: _propTypes2.default.string,
        language: _propTypes2.default.string,
        localeCode: _propTypes2.default.string
    })
};

LocationsContainer.defaultProps = {
    locations: [],
    map: null,
    getLocalizedText: function getLocalizedText(key, defaultValue) {
        return defaultValue;
    },
    locale: {
        country: 'US',
        language: 'en',
        localeCode: 'en_US'
    }
};

exports.default = LocationsContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/LocationsContainer/index.js
// module id = 801
// module chunks = 0